import { useEffect } from 'react'

import { useTexts } from '../../useTexts'

import { form } from '../../formState'

export function NotificationBackup() {
  const texts = useTexts()
  const formApi = form.useFormApi()

  useEffect(() => {
    const unsubscribe = formApi.subscribeToField('backupNotification', field => {
      // EMAIL BACKUP SUBJECT must be visible and required if EMAIL BACKUP is visible and enabled
      const mustProvideBackupSubjectCustom = !!field.visible && field.value === true
      formApi.setFieldVisibleState('backupSubjectCustom', mustProvideBackupSubjectCustom)
    })

    return () => {
      unsubscribe()
    }
  }, [formApi])

  return (
    <form.Checkbox
      helperText={texts.backupNotificationHelperText}
      label={texts.backupNotificationLabel}
      name="backupNotification"
      testId="backupNotification"
      validateOn="focus blur"
    />
  )
}
